import React, { useState } from "react";
import "./style.css";
import Logo from "../../assets/admin.png";
import { Lock, Envelope } from "react-bootstrap-icons";
import { errorAlert } from "../../utils/errorAlert";
import { Container, Row, Button } from "react-bootstrap";
import validator from "validator";
import config from "./../../config";


export default function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = () => {
    if (email.trim() === "") {
      errorAlert({ title: "Error", message: "Email required" });
      return;
    }
    if (!validator.isEmail(email.trim())) {
      errorAlert({
        title: "Error",
        message: "Please enter a valid email",
      });
      return;
    }
    if (password.trim() === "") {
      errorAlert({ title: "Error", message: "Password required" });
      return;
    }
    if (password.length < 6) {
      errorAlert({
        title: "Error",
        message: "Wrong password",
      });
      return;
    }

    fetch(` ${config.url}/api/admin/adminLogin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email.trim(),
        password,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        // swal("response.data");
        if (response.status === "error") {
          errorAlert({
            title: "Error",
            message: response.message,
          });
          return;
        } else {
          localStorage.setItem("token", response.token);
          window.location.assign("/dashboard");
        }

        return response;
      })
      .catch((err) => {
        console.log(err, "Error");
        console.log(err);
        return err;
      });
  };

  return (
    <div className="bgContainer">
      <Row className=" justify-content-center mx-0">
        <img className="my-5 logo img-fluid" src={Logo} alt="Logo.png"></img>
      </Row>
      <Row className=" justify-content-center mx-0">
        <Container className="loginBG ">
          {/* loginBG */}
          <Container className="">
            <form>
              <Row>
                <Container className="d-flex justify-content-around my-3">
                  <span className="align-self-end inputDiv icon">
                    <Envelope color="green=" />
                  </span>
                  <input
                    type="email"
                    className="form-control inputTextField "
                    name="email"
                    placeholder="Enter your E-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        login();
                      }
                    }}
                  />
                </Container>
              </Row>
              <Row>
                <Container className="d-flex my-3">
                  <span className="align-self-end inputDiv icon">
                    <Lock color="green=" />
                  </span>
                  <input
                    type="password"
                    className="form-control inputTextField"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.keyCode === 32) e.preventDefault();
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        login();
                      }
                    }}
                  />
                </Container>
              </Row>
              {/* <Container className="mb-3">
                <Row>
                  {" "}
                  <a href="/getemail" className="anchorTag">
                    Forgot Your Password?
                  </a>
                </Row>
              </Container> */}
              <Row className=" justify-content-center mb-4">
                <Button
                  variant="primary"
                  className="submitButton loginButton"
                  size="md"
                  onClick={() => login()}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      login();
                    }
                  }}
                >
                  <span style={{ fontSize: "17px" }}>LOGIN</span>{" "}
                  <i className="fas fa-arrow-right"></i>
                </Button>{" "}
              </Row>
              {/* <Row className=" justify-content-center">
                <p className="paraText">Need to create an acount?</p>{" "}
              </Row>
              <Row className=" justify-content-center mb-3">
                <a href="/register" className="anchorTag">
                  Register Now
                </a>
              </Row> */}
            </form>
          </Container>
        </Container>
      </Row>
    </div>
  );
}
